<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('inactiveStudent.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('inactiveStudent.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('inactiveStudent.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('inactiveStudent.branchName')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentUnpaid.mainProgram')
                      }}</label>
                      <treeselect
                        :options="main_programs"
                        :placeholder="$t('report.all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.acp_id"
                        @input="onMainProgramChange"
                        :maxHeight="150"
                      ></treeselect>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('studentUnpaid.subProgram')
                      }}</label>
                      <treeselect
                        :options="sub_programs"
                        :placeholder="$t('report.all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.acps_id"
                        :maxHeight="150"
                      ></treeselect>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('inactiveStudent.status') }}</label>
                      <treeselect
                        :options="
                          status.map(i => ({
                            id: i.status_id,
                            label: i.status
                          }))
                        "
                        :placeholder="$t('report.all')"
                        :multiple="true"
                        :limit="1"
                        v-model="model.status_id"
                      ></treeselect>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('inactiveStudent.date')
                      }}</label>
                      <a-range-picker
                        format="DD-MM-YYYY"
                        :defaultValue="rangeDate"
                        :defaultPickerValue="rangeDate"
                        @change="dateRangeChange"
                      >
                        <template slot="renderExtraFooter"></template>
                      </a-range-picker>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('inactiveStudent.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'inactiveStudent',
  data() {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      rangeDate: [moment(), moment()],
      main_programs: [],
      sub_programs: [],
      model: {
        branch_id: null,
        acp_id: [],
        acps_id: [],
        status_id: null
      }
    }
  },
  computed: {
    ...mapState('reportAcademic', ['studentStatus']),
    status() {
      return this.studentStatus.filter(s => s.status_id !== 1)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'getBranch',
      'getMainProgram',
      'getSubProgram',
      'inactiveStudent',
      'getStudentStatus'
    ]),
    async fetchData() {
      this.loading = true
      await this.getStudentStatus()
      await this.getMainProgram().then(response => {
        this.main_programs = response.data.map(el => ({
          id: el.acp_id,
          label: el.acp_name_foreign
        }))
      })
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id = this.$store.state.authUser.default_branch_id
      })
      this.loading = false
    },
    onMainProgramChange() {
      this.model.acps_id = []
      this.fetching = true
      if (this.model.acp_id.length <= 0) {
        this.fetching = false
        return
      }
      this.getSubProgram({
        filter: {
          acp_id: this.model.acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            id: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.inactiveStudent(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'reportAcademic/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'reportAcademic/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    }
  }
}
</script>
